<template>
  <div class="product-view">
    <div class="header-box">
      <div class="header-line">
        <span class="header-label">时区</span>
        <el-select placeholder="请选择" size="small" v-model="dsTimeZone">
          <el-option v-for="item in dsTimeZoneOptions" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
        <span class="header-label">日期</span>
        <el-date-picker v-model="date" type="daterange" align="right" unlink-panels range-separator="至"
          start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions" size="small" value-format="yyyy-MM-dd"
          style="width: 230px;">
        </el-date-picker>
        <span class="header-label">asin</span>
        <el-input size="small" clearable v-model="asin">
        </el-input>
        <span class="header-label">SKU</span>
        <el-input size="small" clearable v-model="sku">
        </el-input>
        <span class="header-label">中文简称</span>
        <el-input size="small" clearable v-model="name">
        </el-input>
      </div>
      <div class="header-line">
        <span class="header-label">状态</span>
        <el-select placeholder="请选择" size="small" v-model="status">
          <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div class="header-line">
        <el-button type="primary" size="small" @click="onQueryBtnClick">查询</el-button>
        <el-button type="primary" size="small" @click="onExportBtnClick" style="float: right;">导出</el-button>
      </div>
    </div>
    <div class="exchange-rate-box">
        <span>汇率：{{rate}}</span>
        <el-button type="text" @click="onExchangeRateEditBtnClick" style="margin-left: 20px;">编辑</el-button>
        <span style="margin-left: 15px">查询数据所在日期区间：</span>
        <span style="color: red;">{{queryDateString}}</span>
        <div style="float: right;margin-top: 10px;" v-if="errorSkuCount > 0">
            <span style="color: red;">合计错误的fnsku数:</span>
            <span style="color: red;" id="errorSkuCount">{{errorSkuCount}}</span>
        </div>
    </div>
    <el-table :data="tableData" border style="width: 100%;" size="small" cell-class-name="table-cell-normal"
      row-class-name="table-row-normal" header-cell-class-name="table-header-cell-normal" :cell-style="expandCellStyle">
      <el-table-column label="序号" width="45px">
        <template slot-scope="scope">
          {{beginIndex + scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column prop="nickname" label="商品" width="50px">
        <template v-slot="img">
          <img style="height: 40px;width: 40px;" :src="img.row.smallImageURL" fit="fill" @click="imageDialogVisible = true;form.id = img.row.id;checkImage = img;">
        </template>
      </el-table-column>
      <el-table-column prop="asin" label="asin" width="70px">
      </el-table-column>
      <el-table-column prop="innerName" label="中文简称" width="100px">
      </el-table-column>
      <el-table-column class-name="no-padding">
        <template slot="header" slot-scope="scope">
          <el-table size="mini" style="height: 47px;" header-cell-class-name="table-header-cell">
            <el-table-column label="SKU" width="100px">
            </el-table-column>
            <el-table-column label="fnSKU" width="100px">
            </el-table-column>
            <el-table-column label="可售" width="55px" align="right">
            </el-table-column>
            <el-table-column label="调拨" width="55px" align="right">
            </el-table-column>
            <el-table-column label="售价" width="80px" align="right">
            </el-table-column>
            <el-table-column label="采购成本" width="55px" align="right">
            </el-table-column>
            <el-table-column label="毛利" width="55px" align="right">
            </el-table-column>
            <el-table-column label="毛利率" width="55px" align="right">
            </el-table-column>
            <el-table-column label="FBA佣金" width="55px" align="right">
            </el-table-column>
            <el-table-column label="头程成本" width="55px" align="right">
            </el-table-column>
            <el-table-column label="FBA配送成本" width="55px" align="right">
            </el-table-column>
            <el-table-column label="质检及包装成本" width="80px" align="right">
            </el-table-column>
            <el-table-column label="仓储费" width="80px" align="right">
            </el-table-column>
            <el-table-column label="操作" width="72px">
            </el-table-column>
          </el-table>
        </template>
        <template slot-scope="scope">
          <el-table :data="scope.row.skuList" size="small" :show-header="false" cell-class-name="table-cell"
            row-class-name="table-row" :ref="'table-'+scope.row.asin">
            <el-table-column width="1" type="expand">
              <template slot-scope="scope">
                <el-table :data="scope.row.amazonProductVOList" border style="width: 100%;" size="small"
                  cell-class-name="table-cell" row-class-name="table-row" :show-header="false">
                  <el-table-column prop="sellerSKU" label="SKU" width="100px">
                  </el-table-column>
                  <el-table-column label="fnSKU" width="100px">
                    <template slot-scope="scope">
                      <el-input v-if="user.role == 7 || scope.row.fnSKU==null || scope.row.fnSKU==''" v-model="scope.row.fnSKU" size="small" @change="((val) => {onTableInputChange(val, scope.row, 'fnSKU')})"
                        @focus="onFocus">
                      </el-input>
                      <span v-if="user.role != 7 && scope.row.fnSKU!=null && scope.row.fnSKU!=''">{{scope.row.fnSKU}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="inStockSupplyQuantity" label="可售" width="55px" align="right">
                  </el-table-column>
                  <el-table-column prop="transferSupplyQuantity" label="调拨" width="55px" align="right">
                  </el-table-column>
                  <el-table-column prop="unitPrice" label="售价" width="80px" align="right">
                    <template slot-scope="scope">
                      <el-input v-if="user.role === 7" v-model="scope.row.unitPrice" size="small" @change="((val) => {onTablePriceInputChange(val, scope.row, 'unitPrice')})"
                        @focus="onFocus">
                      </el-input>
                      <span v-if="user.role !== 7">{{scope.row.unitPrice}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="purchaseCost" label="采购成本" width="55px" align="right">
                  </el-table-column>
                  <el-table-column prop="grossProfit" label="毛利" width="55px" align="right">
                  </el-table-column>
                  <el-table-column prop="grossMargin" label="毛利率" width="55px" align="right">
                  </el-table-column>
                  <el-table-column prop="fbaCommission" label="FBA佣金" width="55px" align="right">
                  </el-table-column>
                  <el-table-column prop="transportCost" label="头程成本" width="55px" align="right">
                  </el-table-column>
                  <el-table-column prop="freight" label="FBA配送成本" width="55px" align="right">
                  </el-table-column>
                  <el-table-column prop="qualityInspectionCost" label="质检及包装成本" width="80px" >
                    <template slot-scope="scope">
                      <el-input v-model="scope.row.qualityInspectionCost" size="small" @change="((val) => {onTableInputChange(val, scope.row, 'qualityInspectionCost')})"
                        @focus="onFocus">
                      </el-input>
                    </template>
                  </el-table-column>
                  <el-table-column prop="storageFee" label="仓储费" width="80px">
                    <template slot-scope="scope">
                      <el-input v-model="scope.row.storageFee" size="small" @change="((val) => {onTableInputChange(val, scope.row, 'storageFee')})"
                        @focus="onFocus">
                      </el-input>
                    </template>
                  </el-table-column>
                </el-table>
              </template>
            </el-table-column>
            <el-table-column prop="sellerSKU" label="SKU" width="100px">
            </el-table-column>
            <el-table-column label="fnSKU" width="100px">
              <template slot-scope="scope">
                <el-input v-if="user.role == 7 || scope.row.fnSKU==null || scope.row.fnSKU==''" v-model="scope.row.fnSKU" size="small" @change="((val) => {onTableInputChange(val, scope.row, 'fnSKU')})"
                  @focus="onFocus">
                </el-input>
                <span v-if="user.role != 7 && scope.row.fnSKU!=null && scope.row.fnSKU!=''">{{scope.row.fnSKU}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="inStockSupplyQuantity" label="可售" width="55px" align="right">
            </el-table-column>
            <el-table-column prop="transferSupplyQuantity" label="调拨" width="55px" align="right">
            </el-table-column>
            <el-table-column prop="unitPrice" label="售价" width="80px" align="right">
              <template slot-scope="scope">
                <el-input v-model="scope.row.unitPrice" v-if="user.role === 7" size="small" @change="((val) => {onTablePriceInputChange(val, scope.row, 'unitPrice')})"
                  @focus="onFocus">
                </el-input>
                <span v-if="user.role !== 7">{{scope.row.unitPrice}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="purchaseCost" label="采购成本" width="55px" align="right">
            </el-table-column>
            <el-table-column prop="grossProfit" label="毛利" width="55px" align="right">
            </el-table-column>
            <el-table-column prop="grossMargin" label="毛利率" width="55px" align="right">
            </el-table-column>
            <el-table-column prop="fbaCommission" label="FBA佣金" width="55px" align="right">
            </el-table-column>
            <el-table-column prop="transportCost" label="头程成本" width="55px" align="right">
            </el-table-column>
            <el-table-column prop="freight" label="FBA配送成本" width="55px" align="right">
            </el-table-column>
            <el-table-column prop="qualityInspectionCost" label="质检及包装成本" width="80px">
              <template slot-scope="scope">
                <el-input v-model="scope.row.qualityInspectionCost" size="small" @change="((val) => {onTableInputChange(val, scope.row, 'qualityInspectionCost')})"
                  @focus="onFocus">
                </el-input>
              </template>
            </el-table-column>
            <el-table-column prop="storageFee" label="仓储费" width="80px">
              <template slot-scope="scope">
                <el-input v-model="scope.row.storageFee" size="small" @change="((val) => {onTableInputChange(val, scope.row, 'storageFee')})"
                  @focus="onFocus">
                </el-input>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="72px">
              <template slot-scope="scope">
                <el-button type="text" class="blue" @click="onExpandChange(scope.row)" v-if="scope.row.amazonProductVOList.length > 0">展开</el-button>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog title="批量修改竞价" :visible.sync="imageDialogVisible" width="300px">
      <div>
        <input type="file" accept="image/*" id="imageUrl" @change="onImageChange">
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="imageDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSuccess">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import {
    productModules
  } from '@r'
  import utils from '../../utils/utils.js'
  export default {
    props: {
      country: {
        type: String
      }
    },
    data() {
      return {
        form: {
          id: undefined,
          imageBASE64: '',
        },
        checkImage: {},
        dialogImageUrl: '',
        imageDialogVisible: false,
        disabled: false,
        expands: [],
        oldTableData: [],
        queryDateString: '',
        beginIndex: 0,
        pageSize: 10000,
        totalPage: 1,
        currentPage: 1,
        asin: "",
        sku: "",
        status: "",
        statusOptions: [{
            value: "",
            label: "全部"
          },
          {
            value: 1,
            label: "在售"
          },
          {
            value: 0,
            label: "停售"
          }
        ],
        beginDate: "",
        endDate: "",
        dsTimeZone: 0,
        date: [new Date(new Date().getTime() - 24 * 3600 * 1000 * 30).format("yyyy-MM-dd"), new Date(new Date().getTime() + 86400000).format("yyyy-MM-dd")],
        dsTimeZoneOptions: [{
            value: 0,
            label: "北京时间"
          },
          {
            value: 1,
            label: "美国PST时间"
          }
        ],
        name: "",
        rate: "",
        errorSkuCount: 0,
        pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }]
        },
      }
    },
    activated() {
      this.listAmazonProductGroupByAsin();
      this.getExchangeRate();
    },
    created(){
        this.asin=this.$route.query.asin;
    },
    methods: {
      onTableInputChange(val, row, propName) {
        this.$confirm('是否确认修改?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          var params = new FormData();
          params.append("id", row.id);
          propName=="fnSKU" && params.append("fnSKU", row.fnSKU);
          propName=="qualityInspectionCost" && params.append("qualityInspectionCost", row.qualityInspectionCost);
          propName=="storageFee" && params.append("storageFee", row.storageFee);

          productModules.editAmazonProduct(params).then((res) => {
            if (res.result !== 1) {
              this.$message({
                type: 'error',
                message: res.message ? res.message : '编辑失败'
              });
              return;
            }
            this.$message({
              type: 'success',
              message: '编辑成功!'
            });
            this.listAmazonProductGroupByAsin();
          }).catch((err) => {
            console.log(err);
            this.$message({
              type: 'error',
              message: err.message ? err.message : '编辑失败'
            });
          });
        }).catch(() => {
          row[propName] = this.focusValue
          this.$message({
            type: 'info',
            message: '已取消'
          })
        });
      },
      onTablePriceInputChange(val, row, propName) {
        this.$confirm('是否确认修改?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          var params = new FormData();
          params.append("id", row.id);
          params.append("unitPrice", row.unitPrice)
          productModules.editAmazonProductPrice(params).then((res) => {
            if (res.result !== 1) {
              this.$message({
                type: 'error',
                message: res.message ? res.message : '编辑失败'
              });
              return;
            }
            this.$message({
              type: 'success',
              message: '编辑成功!'
            });
            this.listAmazonProductGroupByAsin();
          }).catch((err) => {
            console.log(err);
            this.$message({
              type: 'error',
              message: err.message ? err.message : '编辑失败'
            });
          });
        }).catch(() => {
          row[propName] = this.focusValue
          this.$message({
            type: 'info',
            message: '已取消'
          })
        });
      },
      onFocus(e) {
        this.focusValue = e.currentTarget.value
      },
      onQueryBtnClick() {
        this.listAmazonProductGroupByAsin();
      },
      onExportBtnClick(){
        let sku = this.sku?  "&sku=" + this.sku : "";
        let asin = this.asin? "&asin=" + this.asin : "";
        let status = this.status? "&status=" + this.status : "";
        window.open("/api/amazonProduct/exportAmazonProduct?&beginDate="+this.date[0]
          +"&endDate="+this.date[1]+"&dsTimeZone="+this.dsTimeZone+"&country="+this.country + sku + asin + status);
      },
      onExchangeRateEditBtnClick(){
        this.$prompt('汇率', '编辑汇率', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputType: "number",
          inputValue: this.rate
        }).then(({ value }) => {
          if(value == ""){
            this.$message({
              type: "warning",
              message: "请输入汇率"
            });
            return;
          }

          productModules.editExchangeRate({
              rate: value,
              country: this.country
            })
            .then(res => {
              if (res.result !== 1) {
                this.$message({
                  type: "error",
                  message: res.message ? res.message : "添加供应商名称失败"
                });
                return;
              }
              this.$message({
                type: "success",
                message: "修改成功"
              });
              this.rate = value;
            })
            .catch(err => {
              this.$message({
                type: "error",
                message: err.message ? err.message : "添加供应商名称失败"
              });
            });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });
      },
      listAmazonProductGroupByAsin() {
        productModules.listAmazonProductGroupByAsin({
          "asin": this.asin,
          "sku": this.sku,
          "status": this.status,
          "beginDate": this.date[0],
          "endDate": this.date[1],
          "dsTimeZone": this.dsTimeZone,
          'country': this.country,
          'name': this.name
        }).then((res) => {
          if (res.result !== 1) {
            this.$message({
              type: 'error',
              message: res.message ? res.message : '获取列表失败'
            });
            return
          }
          this.queryDateString = this.date[0] + '至' + this.date[1];
          this.oldTableData = res.ldata;
          this.currentPage = this.beginIndex / this.pageSize + 1;
          if (this.oldTableData.length >= this.pageSize) {
            this.oldTableData.pop();
            this.oldTableData = this.currentPage + 1;
          }
        }).catch((err) => {
          this.$message({
            type: 'error',
            message: err.message ? err.message : '未知错误'
          });
        })
      },
      getExchangeRate() {
        productModules.getExchangeRate({
          'country': this.country
        }).then((res) => {
          if (res.result !== 1) {
            this.$message({
              type: 'error',
              message: res.message ? res.message : '获取汇率失败'
            });
            return
          }

          this.rate = res.mdata.rate;
        }).catch((err) => {
          this.$message({
            type: 'error',
            message: err.message ? err.message : '未知错误'
          });
        })
      },
      expandCellStyle({row, column, rowIndex, columnIndex}){
        if(columnIndex == 4){
          return "padding:0px !important";
        }
      },
      onExpandChange(row){
        this.$refs["table-"+row.asin].toggleRowExpansion(row);
      },
      onImageChange(e){
        if(!this.checkImage.row){
          return true;
        }
        utils.localResizeImg(e, this.form, "imageBASE64");
      },
      handleSuccess() {
        this.checkImage.row.smallImageURL = this.form.imageUrl;
        var params = new FormData();
        params.append("id",this.form.id);
        params.append("imageBASE64",this.form.imageBASE64);
        productModules.editAmazonProductForAsin(params).then((res) => {
          if (res.result !== 1) {
            this.$message({
              type: 'error',
              message: res.message ? res.message : '上传图片失败'
            });
            return
          }
          this.$message({
            type: 'success',
            message: res.message ? res.message : '上传图片成功'
          });
          this.imageDialogVisible = false;
          productModules.listAmazonProductGroupByAsin({
            "asin": this.checkImage.row.asin,
            "status": this.status,
            "beginDate": this.date[0],
            "endDate": this.date[1],
            "dsTimeZone": this.dsTimeZone,
            'country': this.country,
          }).then((res) => {
            if (res.result !== 1) {
              this.$message({
                type: 'error',
                message: res.message ? res.message : '获取列表失败'
              });
              return
            }
            this.checkImage.row.smallImageURL = res.ldata[0].smallImageURL;

          }).catch((err) => {
            this.$message({
              type: 'error',
              message: err.message ? err.message : '未知错误'
            });
          });
        }).catch((err) => {
          this.$message({
            type: 'error',
            message: err.message ? err.message : '未知错误'
          });
        })
      },
    },
    computed: {
      tableData (){
        let newtable = [];
        this.oldTableData.forEach((item, index) => {
          if (item.amazonProductVOList.length == 0) {
            return;
          }
          var prodInfo = {
            ...item,
            skuList: [{
              ...item.amazonProductVOList[0],
              amazonProductVOList: item.amazonProductVOList.slice(1, item.amazonProductVOList.length)
            }]
          }
          newtable.push(prodInfo);
        });
        return newtable;
      },
      user () {
        let userInfo = this.$store.state.userInfo;
        if(userInfo == null){
          this.$store.dispatch('REFRESH_USER_INFO').then((res) => {
            console.log(res);
          }).catch((err) => {
            console.log(err);
          })
        }
        return this.$store.state.userInfo || {};
      },
    }
  }
</script>

<style lang="scss">
  .no-padding{
    padding: 0px !important;
    .cell{
      padding: 0px !important;
    }
  }
  .exchange-rate-box{
    border-left: 1px solid #EBEEF5;
    border-right: 1px solid #EBEEF5;
    border-top: 1px solid #EBEEF5;
    padding: 10px;
  }
</style>
